import { render } from "./RouterLinkButton.vue?vue&type=template&id=1f567721&scoped=true"
import script from "./RouterLinkButton.vue?vue&type=script&lang=js"
export * from "./RouterLinkButton.vue?vue&type=script&lang=js"

import "./RouterLinkButton.vue?vue&type=style&index=0&id=1f567721&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f567721"]])

export default __exports__